
export const environment = {
  production: false,
  baseUrl: 'https://abeokuta.vicpharm.store/apis/v1/vicPharm/',
  ecommerceUrl: 'https://abeokuta.vicpharm.store/apis/v1/online/ecommerce/'
};